import { Button, HStack, Heading, VStack, chakra } from "@chakra-ui/react";
import { FaCloudDownloadAlt } from "react-icons/fa";

const DownloadReportButton = ({
  title,
  url,
}: {
  title?: string;
  url?: string;
}) => {
  return (
    <VStack w={"full"} my={2} alignItems={"flex-start"} gap={2}>
      <Heading w="full" size="sm" py={2}>
        {title}
      </Heading>
      <Button
        isDisabled={!url}
        onClick={() => window.open(url, "_blank")}
        aria-label="Download event report"
        variant={"outline"}
        leftIcon={<FaCloudDownloadAlt />}
      >
        Download {title}
      </Button>
    </VStack>
  );
};

export default DownloadReportButton;
